import ctmLogo from './assets/ctm-logo.svg';

const LogoIcon = () => {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        height: '100%',
      }}
    >
      <img
        src={ctmLogo}
        alt="CTM"
        width={36}
        height={32}
        style={{ objectFit: 'contain', display: 'block' }}
      />
      <span
        style={{
          fontSize: 18,
          fontWeight: 600,
          lineHeight: '20px',
          whiteSpace: 'nowrap',
        }}
      >
        CTM Backstage
      </span>
    </span>
  );
};

export default LogoIcon;
